import Vue from 'vue';
import http from 'axios';
import Plyr from 'plyr/dist/plyr.polyfilled';
import { Video } from '@app/global/video';
import { EventTracking, EventType } from '@app/tracking';
export default Vue.extend({
    props: {
        uri: String
    },
    data: function () { return ({
        player: null,
        fullVideo: null,
        fullVideoSource: null,
        fullVideoPlaying: false,
        fullVideoShow: false,
        controlsShown: false
    }); },
    mounted: function () {
        var _this = this;
        if (this.uri) {
            http.get('/api/video/' + this.uri.replace('/videos/', '')).then(function (res) {
                _this.fullVideo = _this.$refs.fullVideo;
                _this.fullVideoSource = res.data;
                _this.$nextTick(function () {
                    _this.player = new Plyr(_this.$refs.fullVideo);
                    _this.setupVideo();
                    new Video(_this.$refs.fullVideo, {
                        adaptiveStreaming: true
                    });
                    _this.$emit('ready');
                });
            });
        }
    },
    methods: {
        playPauseVideo: function () {
            if (this.fullVideo.paused) {
                this.fullVideo.play();
            }
            else {
                this.fullVideo.pause();
            }
        },
        closeVideo: function () {
            var percentageOfVideoPlayed = Math.round(100 / this.fullVideo.duration * this.fullVideo.currentTime);
            if (this.player.fullscreen.active) {
                this.player.fullscreen.exit();
            }
            this.fullVideo.pause();
            this.fullVideo.currentTime = 0;
            this.fullVideoShow = false;
            EventTracking.dispatch(EventType.Track, {
                category: 'Video',
                action: 'close',
                label: this.fullVideoSource.name,
                value: percentageOfVideoPlayed
            });
        },
        setupVideo: function () {
            var _this = this;
            this.fullVideo = this.$refs.fullVideo;
            this.player.on('controlsshown', function () { return _this.controlsShown = true; });
            this.player.on('controlshidden', function () { return _this.controlsShown = false; });
        },
        fullPlay: function () {
            this.fullVideoShow = true;
            this.fullVideoPlaying = true;
            EventTracking.dispatch(EventType.Track, {
                category: 'Video',
                action: 'play',
                label: this.fullVideoSource.name
            });
        },
        fullPause: function () {
            this.fullVideoPlaying = false;
            EventTracking.dispatch(EventType.Track, {
                category: 'Video',
                action: 'play',
                label: this.fullVideoSource.name
            });
        },
        fullEnded: function () {
            if (this.player.fullscreen.active) {
                this.player.fullscreen.exit();
            }
            this.fullVideoShow = false;
            this.fullVideoPlaying = false;
        },
    },
    watch: {
        fullVideoShow: function (newVal) {
            if (newVal == true) {
                document.body.classList.add('js-active');
            }
            else {
                document.body.classList.remove('js-active');
            }
        },
    }
});
